import React from "react";

import "./index.scss";

export default function Switch({
  id,
  label1,
  label2,
  value = false,
  handleSwitch,
}) {
  return (
    <div className="switch">
      <input type="checkbox" id={id} checked={value} onChange={handleSwitch} />
      <label htmlFor={id}>
        <span>{label1}</span>
        <div className="switch__box"></div>
        <span>{label2}</span>
      </label>
    </div>
  );
}
